import React from 'react';
import { Link } from 'gatsby';

export const ResourceLink = ({ slug, title }) => (
  <Link className="resource-link__item" to={`/resources/${slug}`}>
    {title}
  </Link>
);
